import React, { useState } from 'react';
import ClubImage from '../../../../components/ClubImage/ClubImage';

import styles from './Club.module.scss';

export const Club = ({club}) => {
  return (
    <section className={styles.clubContainer}>
      <div className={styles.imageContainer}>
        <ClubImage clubName={club?.name} path={club?.pathPhoto}/>
      </div>
      <h1>{club?.name}</h1>
    </section>
  )
}

export default Club;